import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b72e496")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isShowMultipleOption && _ctx.filterOption())
    ? (_openBlock(), _createBlock("li", {
        key: 0,
        title: _ctx.label,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.choose && _ctx.choose(...args))),
        class: [_ctx.selected.selected == _ctx.value ? 'selected-active' : '', _ctx.disabled ? 'disable' : '']
      }, _toDisplayString(_ctx.label), 11, ["title"]))
    : _createCommentVNode("", true)
})